import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import DataList from 'components/organisms/Lists/DataList/DataList';

const StyledInsightsList = styled(DataList)`
  &.InsightsList {
    .ListItem {
      &:focus {
        padding-left: 20px;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledInsightsList.propTypes = {
  theme: PropTypes.object
};

export default StyledInsightsList;
